import React from 'react';
import classNames from 'classnames';
import { useRecoilState, useRecoilValue } from 'recoil';
import AddressAutocomplete from './AddressAutocomplete/AddressAutocomplete';
import * as AppState from '../../../AppState';
import { CircleButton } from '@capcenter/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Search.scss';

const Search: React.FC = (props: any, test: any) => {
	const gsIsMobile = useRecoilValue(AppState.gsIsMobile);
	const [gsLocationAutoCompleteValue, setGsLocationAutoCompleteValue] = useRecoilState(
		AppState.gsLocationAutoCompleteValue,
	);

	return (
		<div className="home-search__search-wrapper">
			<div className={classNames("input-group", gsIsMobile && 'h-100')}>
				<div className="input-group-prepend">
					<span className={classNames('input-group-text h-100 bg-white border-right-0', gsIsMobile && 'px-2')}>
						<FontAwesomeIcon
							icon={['far', 'search']}
							className={classNames(gsIsMobile && 'small', 'cc-color--gray-500')}
						/>
					</span>
				</div>

				<AddressAutocomplete />

				{/* TODO [DG]: clear gsUserLocation on click */}
				{gsLocationAutoCompleteValue && (
					<CircleButton
						color="gray"
						variant="flat"
						icon="far fa-times pt-1"
						onClick={() => setGsLocationAutoCompleteValue('')}
						className="home-search__autocomplete-clear-search-item"
						size={gsIsMobile ? 'sm' : 'md'}
					/>
				)}
			</div>
		</div>
	);
};

export default Search;
